import { useState } from "react";
import "./descriptionInput.css";

type DescriptionInputProps = {
  id?: string;
  name?: string;
  placeholder?: string;
  value: string;
  onChangeText: (text: any) => void;
  label?: string;
  error?: string;
  inputRef?: any;
  onKeyDown?: (text: any) => void;
  textareaMainContainerClassName?: any;
  textareaSelectStyle?: any;
};

const DescriptionInput = ({
  id,
  name,
  placeholder,
  value,
  onChangeText,
  label,
  error,
  inputRef,
  onKeyDown,
  textareaMainContainerClassName,
  textareaSelectStyle,
}: DescriptionInputProps) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleOnFocus = () => {
    setIsFocused(!isFocused);
  };

  const handleBlur = () => {
    setIsFocused(!isFocused);
  };

  return (
    <div className={`textareaMainContainer ${textareaMainContainerClassName}`}>
      <p className="headingBlueColor inputLabel">{label}</p>
      {/*headingBlueColor is in App.css*/}
      <textarea
        id={id}
        placeholder={placeholder}
        name={name}
        value={value}
        rows={5}
        onChange={(e) => onChangeText(e.target.value)}
        onFocus={handleOnFocus}
        onBlur={handleBlur}
        ref={inputRef}
        onKeyDown={onKeyDown}
        className={`textareaSelect ${textareaSelectStyle}`}
        style={{
          border: isFocused ? "1px solid #014792" : ".1px solid #ededed",
        }}
      />
      <p className="error">{error || error}</p>
    </div>
  );
};

export default DescriptionInput;
